const days = [
    { value: '01', text: '01' },
    { value: '02', text: '02' },
    { value: '03', text: '03' },
    { value: '04', text: '04' },
    { value: '05', text: '05' },
    { value: '06', text: '06' },
    { value: '07', text: '07' },
    { value: '08', text: '08' },
    { value: '09', text: '09' },
    { value: '10', text: '10' },
    { value: '11', text: '11' },
    { value: '12', text: '12' },
    { value: '13', text: '13' },
    { value: '14', text: '14' },
    { value: '15', text: '15' },
    { value: '16', text: '16' },
    { value: '17', text: '17' },
    { value: '18', text: '18' },
    { value: '19', text: '19' },
    { value: '20', text: '20' },
    { value: '21', text: '21' },
    { value: '22', text: '22' },
    { value: '23', text: '23' },
    { value: '24', text: '24' },
    { value: '25', text: '25' },
    { value: '26', text: '26' },
    { value: '27', text: '27' },
    { value: '28', text: '28' },
    { value: '29', text: '29' },
    { value: '30', text: '30' },
    { value: '31', text: '31' }
]
const months = [
    { value: '01', translationKey: 'Formlabels.BirthdateMonth.January' },
    { value: '02', translationKey: 'Formlabels.BirthdateMonth.February' },
    { value: '03', translationKey: 'Formlabels.BirthdateMonth.March' },
    { value: '04', translationKey: 'Formlabels.BirthdateMonth.April' },
    { value: '05', translationKey: 'Formlabels.BirthdateMonth.May' },
    { value: '06', translationKey: 'Formlabels.BirthdateMonth.June' },
    { value: '07', translationKey: 'Formlabels.BirthdateMonth.July' },
    { value: '08', translationKey: 'Formlabels.BirthdateMonth.August' },
    { value: '09', translationKey: 'Formlabels.BirthdateMonth.September' },
    { value: '10', translationKey: 'Formlabels.BirthdateMonth.October' },
    { value: '11', translationKey: 'Formlabels.BirthdateMonth.November' },
    { value: '12', translationKey: 'Formlabels.BirthdateMonth.December' }
]
const years = []
let startYear = new Date().getFullYear()
let currentYear = startYear
while (currentYear >= startYear - 100) {
    years.push({
        value: `${currentYear}`,
        text: `${currentYear}`
    })
    currentYear--
}

const extractBirthday = (dateOfBirth = '') => {
    if (!dateOfBirth) {
        return { birthdayDay: '', birthdayMonth: '', birthdayYear: '' }
    }

    const [birthdayYear, birthdayMonth, birthdayDay] = dateOfBirth.split('-')
    return { birthdayDay, birthdayMonth, birthdayYear }
}

export { years, months, days, extractBirthday }
